import { useSelector } from 'hooks/utils';
import { selectFormHasChanges } from 'store/data/forms';

export function useFormHasChanges() {
	return useSelector(state => selectFormHasChanges(state.data.forms));
}
